<template>
    <div class="payment-history">
        <h1>{{ $t('payment_history.title') }}</h1>
        <template v-if='!isMobile'>
            <ul class="year-filter">
                <li v-for="(item, index) in [
                        'all', ...years
                    ]"
                    :key="index"
                    :class="{
                        'active': year === item
                    }"
                    @click="year = item;page = 1">{{ item === 'all' ? $t('all') : item }}</li>
            </ul>
        </template>
        <div class='type-filter' v-else>
            <span>{{$t('payment_history.year')}}</span>
            <reo-select
                ref="yearSelect"
                class="year-select"
                :widthOut='selectorStyle.widthOut'
                :heightOut='selectorStyle.heightOut'
                :widthIn='selectorStyle.widthIn'
                :heightIn='selectorStyle.heightIn'
                :selectMarginLeft='selectorStyle.selectMarginLeft'
                :triangleRight='selectorStyle.triangleRight'
                :fontSizeIn ='selectorStyle.fontSizeIn'
                :fontSizeOut='selectorStyle.fontSizeOut'
                :maxHeight ='selectorStyle.maxHeight'
                :defaultSelected="defaultYearSelected"
                :key='type'
                :options="yearsOptions"
                @input="handleYearChange"
                @dialogMounted='dialogMounted'
                @dialogDestroyed="dialogDestroyed">
            </reo-select>
        </div>

        <table class="reo-table" v-if="!isMobile && hasData">
            <thead >
                <th>{{ $t('payment_history.id_label') }}</th>
                <th>{{ $t('payment_history.date_label') }}</th>
                <th>{{ $t('payment_history.tax_label') }}</th>
                <th>{{ $t('payment_history.total_label') }}</th>
                <th>{{ $t('payment_history.plan_label') }}</th>
                <th>{{ $t('payment_history.sim_card_label') }}</th>
                <th>{{ $t('payment_history.status_label') }}</th>
            </thead>
            <tbody>
                <template v-if='paymentList.length>0'>
                    <tr v-for="(payment, index) in paymentList" :key="index">
                        <td>#{{ payment.id }}</td>
                        <td>{{ $t( 'date_format.default' ,{

                            year: timeResolve( payment.createdAt ).year,
                            month: timeResolve( payment.createdAt ).month,
                            day: timeResolve( payment.createdAt ).dateOfMonth

                        }) }}</td>
                        <td>
                            <span>{{ `${payment.currency} ${payment.totalTax.toFixed(2)}` }}</span>
                        </td>
                        <td>
                            <span :class="{ 'del sub-note': Number(payment.refundingAmount) === 0 && Number(payment.refundedAmount) > 0 }">
                                {{ `${payment.currency} ${payment.amount}` }}
                            </span>
                            <template v-if="Number(payment.refundingAmount) > 0">
                                <br />
                                <span>
                                    {{ $t('payment_history.refunding') }}
                                </span>
                            </template>
                            <template v-else-if="Number(payment.refundedAmount) > 0">
                                <br />
                                <span>
                                    {{ `${payment.currency} ${Number(payment.amount - payment.refundedAmount).toFixed(2)}` }} {{ $t('payment_history.refunded') }}
                                </span>
                            </template>
                        </td>
                        <showMoreTd @click="showDetail(index)">
                            <span class="payment-product" v-for="(item, index) in payment.items" :key="index">
                                {{ item.name }}<span v-if="item.productType==='cloud_data_add_on_plan'"> * {{ item.quantity }}</span>
                                <br/>
                                <span class="sub-note" v-if="item.productType!=='cloud_data_add_on_plan' && item.plan?.cycle">
                                    ({{ $tc( `cycle_short.${item.plan?.cycle.interval.unit}`, item.plan?.cycle.interval.frequency, {

                                        count: item.plan?.cycle.interval.frequency

                                    }) }})
                                    *
                                    {{ item.quantity }}
                                </span>

                            </span>
                        </showMoreTd>
                        <showMoreTd @click="showDetail(index)">
                            <div v-for="item in getSimRelateItems(payment)" :key="item.id">
                                <div v-for="simCard in (item.context.associateSimCards ?? [])" :key="simCard.iccid">
                                    {{simCard.simCardCode}}({{$t('dashboard.device_detail.main_card.iccid')+simCard.iccid}})
                                </div>
                            </div>
                        </showMoreTd>
                        <td>
                            <!-- paypal收款状态 -->
                            <div
                                v-if="payment.status.currStage === currentStage.PAYMENT
                                    && payment.status.paymentStatus===paymentStatus.CLOSED && payment.closedReason==='paymendivenied'">
                                {{ $t(`payment_status.closed`) }}
                            </div>

                            <!-- 订单未支付过期 -->
                            <div v-else-if="payment.status.currStage === currentStage.PAYMENT
                                && payment.status.paymentStatus===paymentStatus.CLOSED && payment.closedReason==='expired'">
                                {{ $t(`payment_status.expired`) }}
                            </div>

                            <!-- 正在退款 -->
                            <div v-else-if="payment.status.currStage === currentStage.POSTSALE
                                && payment.status.postSaleStatus===postSaleStatus.REFUNDING
                                && Number(payment.refundingAmount)!==0">
                                {{ $t(`payment_status.refunding`) }}
                            </div>

                            <!-- 全部退款 -->
                            <div v-else-if="payment.status.currStage === currentStage.POSTSALE
                                && (payment.status.postSaleStatus===postSaleStatus.CLOSED||payment.status.postSaleStatus===postSaleStatus.REFUNDING)
                                && Number(payment.refundingAmount)===0">
                                {{ $t(`payment_status.refunded`) }}
                            </div>

                            <div v-else>
                                {{ $t(`payment_status.${payment.status.paymentStatus}`) }}
                            </div>
                            <div>
                                <a class="text-link invoice" v-if="payment.status.paymentStatus === paymentStatus.CREATED" @click='goPay(payment.id)'>
                                    {{ $t('payment_history.pay_now') }}
                                </a>
                                <router-link class="text-link invoice"
                                    v-else-if="payment.status.paymentStatus === paymentStatus.COMPLETED"
                                    :to="`/user/invoice/${payment.id}/`"
                                    target="_blank">
                                    {{ $t('payment_history.invoice') }}
                                </router-link>
                            </div>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
        <div class="reo-table-mobile" v-show="hasData">
            <div class="cards" v-if='paymentList.length>0'>
                <ul v-for="(payment, index) in paymentList" :key="index">
                    <li>
                        <label>{{ $t('payment_history.id_label') }}</label>
                        <span>#{{ payment.id }}</span>
                    </li>
                    <li>
                        <label>{{ $t('payment_history.date_label') }}</label>
                        <span>{{ $t( 'date_format.default' ,{

                            year: timeResolve( payment.createdAt ).year,
                            month: timeResolve( payment.createdAt ).month,
                            day: timeResolve( payment.createdAt ).dateOfMonth

                        }) }}</span>
                    </li>
                    <li>
                        <label>{{$t('payment_history.tax_label')}}</label>
                        <span>{{ `${payment.currency} ${payment.totalTax.toFixed(2)}`}}</span>
                    </li>
                    <li>
                        <label>{{ $t('payment_history.total_label') }}</label>
                        <span>
                            <span :class="{ 'del sub-note': Number(payment.refundingAmount) === 0 && Number(payment.refundedAmount) > 0 }">
                                {{ `${payment.currency} ${payment.amount}` }}
                            </span>
                            <template v-if="Number(payment.refundingAmount) > 0">
                                <br />
                                <span>
                                    {{ $t('payment_history.refunding') }}
                                </span>
                            </template>
                            <template v-else-if="Number(payment.refundedAmount) > 0">
                                <br />
                                <span>
                                    {{ `${payment.currency} ${Number(payment.amount - payment.refundedAmount).toFixed(2)}` }} {{ $t('payment_history.refunded') }}
                                </span>
                            </template>
                        </span>
                    </li>
                    <li>
                        <label>{{ $t('payment_history.plan_label') }}</label>
                        <span>
                            <span class="payment-product" v-for="(item, index) in payment.items" :key="index">
                                {{ item.name }}
                                <span v-if="item.productType!=='cloud_data_add_on_plan' && item.plan?.cycle">

                                    ({{ $tc( `cycle_short.${item.plan.cycle.interval.unit}`, item.plan.cycle.interval.frequency, {

                                        count: item.plan.cycle.interval.frequency

                                    }) }})
                                </span>
                                *
                                {{ item.quantity }}

                            </span >
                        </span>
                    </li>
                    <li v-if="getSimRelateItems(payment).length>0">
                        <label>{{ $t('payment_history.sim_card_label') }}</label>
                        <span>
                            <span v-for="item in getSimRelateItems(payment)" :key="item.id">
                                <div v-for="simCard in (item.context.associateSimCards ?? [])" :key="simCard.iccid">
                                    {{simCard.simCardCode}}({{$t('dashboard.device_detail.main_card.iccid')+simCard.iccid}})
                                </div>
                            </span>
                        </span>
                    </li>
                    <li>
                        <label>{{ $t('payment_history.status_label') }}</label>
                        <span>
                            <div
                                v-if="payment.status.currStage === 'payment'
                                    && payment.status.paymentStatus === paymentStatus.CREATED "
                                @click='goPay(payment.id)'>
                                {{ $t(`payment_status.created`) }}
                            </div>

                            <!-- paypal收款状态 -->
                            <span
                                v-else-if="payment.status.currStage === currentStage.PAYMENT
                                    && payment.status.paymentStatus===paymentStatus.CLOSED && payment.closedReason==='paymentDenied'">
                                {{ $t(`payment_status.closed`) }}
                            </span>

                            <!-- 订单未支付过期 -->
                            <span v-else-if="payment.status.currStage === currentStage.PAYMENT
                                && payment.status.paymentStatus===paymentStatus.CLOSED && payment.closedReason==='expired'">
                                {{ $t(`payment_status.expired`) }}
                            </span>

                            <!-- 正在退款 -->
                            <span v-else-if="payment.status.currStage === currentStage.POSTSALE
                                && payment.status.postSaleStatus===postSaleStatus.REFUNDING
                                && Number(payment.refundingAmount)!==0">
                                {{ $t(`payment_status.refunding`) }}
                            </span>

                            <!-- 全部退款 -->
                            <span v-else-if="payment.status.currStage === currentStage.POSTSALE
                                && (payment.status.postSaleStatus===postSaleStatus.CLOSED || payment.status.postSaleStatus===postSaleStatus.REFUNDING)
                                && Number(payment.refundingAmount)===0">
                                {{ $t(`payment_status.refunded`) }}
                            </span>

                            <span v-else>
                                {{ $t(`payment_status.${payment.status.paymentStatus}`) }}
                            </span>
                        </span>
                    </li>
                    <li class="invoice-li"
                        v-if=" (payment.status.currStage === 'payment'&&payment.status.paymentStatus === paymentStatus.CREATED )
                            || payment.status.paymentStatus === paymentStatus.COMPLETED"
                    >
                        <a class="text-link invoice"
                            v-if="payment.status.currStage === 'payment'
                                && payment.status.paymentStatus === paymentStatus.CREATED "
                            @click='goPay(payment.id)'>
                            {{ $t('payment_history.pay_now') }}
                        </a>
                        <!-- 完成 -->
                        <router-link class="text-link invoice"
                            v-if="payment.status.paymentStatus === paymentStatus.COMPLETED"
                            :to="`/user/invoice/${payment.id}/`"
                            target="_blank">
                            {{ $t('payment_history.invoice') }}
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
        <div class="no-data" v-if="paymentList.length === 0">
            <img :src="EmptyImage"/>
            <p class="text">{{$t('dashboard.noData')}}</p>
        </div>
        <infiniteLoading spinner="spiral"
            class="loading"
            @infinite="infiniteHandler"
            v-if="hasMore"></infiniteLoading>
        <a href="javascript:void(0);"
            v-if="hasMore"
            class="more-payments"
            @click="getHistory(++page)">
            <span>{{ $t('payment_history.load_more') }}</span>
            <i class="icon-icon_arrow-down"></i>
        </a>
        <!-- <a href="javascript:void(0);" v-if="paymentList.length > 20" class="less-payments" @click="showless">
            <span>{{ $t('payment_history.show_less') }}</span>
            <i class="icon-icon_arrow-up"></i>
        </a> -->
        <DetailDialog
            v-model="detailDialog.show"
            :payment="paymentList[detailDialog.paymentIndex]"
            @goPay="goPay"
        />
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { AxiosError } from 'axios';
import nprogress from 'nprogress';
import InfiniteLoading from 'vue-infinite-loading';
import { config } from 'CONFIG';
import ReoSelect from '@/basic/ReoSelect.vue';
import router from '@/router';
import { getPaymentHistory, getOrderDetailById } from '@/api/cart';
import { ITimeObject, timeResolve } from '@/common/js/date';
import { payment as paymentStatus, currStage as currentStage, postSale as postSaleStatus } from '@/config/status';
import { unfoldError } from '@/common/js/notice';
import { ECommonButtonType, IOrder, ISelectorStyle } from '@reolink-cloud/interface';
import { productsManager } from '@/lib';
import showMoreTd from './components/showMoreTd.vue';
import DetailDialog from './components/DetailDialog.vue';
import EmptyImage from 'IMAGE/dashboard/noDevice.webp';

interface IYearsOptions {
    label: number | string;
    value: number | string;
    id: number | string;
}

export default Vue.extend({

    components: {

        InfiniteLoading,
        ReoSelect,
        showMoreTd,
        DetailDialog

    },

    data () {

        let now = new Date().getFullYear();
        let year = 2018;
        let years: number[] = [];
        let yearsOptions: IYearsOptions[] = [];
        while ( year < now + 1 ) {

            years.unshift( year );
            yearsOptions.unshift({
                label: year,
                value: year,
                id: year
            });
            year++;

        }
        yearsOptions.unshift({
            label: this.$tc( 'payment_history.selector.all_label' ),
            value: 'total',
            id: 'total'
        });
        return {

            paymentList: [] as any[],
            hasMore: false,
            per: 20,
            years,
            year: 'all' as string | number,
            paymentStatus,
            currentStage,
            postSaleStatus,
            products: {},
            page: 1,
            yearsOptions,
            options: [
                {
                    label: this.$tc( 'payment_history.selector.all_label' ),
                    value: 'total',
                    id: 'total'
                },
                {
                    label: this.$tc( 'payment_history.selector.cloud_label' ),
                    value: 'storage_plan',
                    id: 'storage_plan'
                },
                {
                    label: this.$tc( 'payment_history.selector.view_label' ),
                    value: 'traffic_plan',
                    id: 'traffic_plan'
                }
            ],
            type: 'total',
            dialogStack: [] as any[],
            initialized: false,
            defaultSelected: 'total',
            defaultYearSelected: 'total',
            ECommonButtonType,
            detailDialog: {
                paymentIndex: 0,
                show: false
            },
            EmptyImage
        };

    },
    async created () {

        await productsManager.update({ lang: this.$i18n.locale });
        await this.getHistory( 1 );
        this.initialized = true;
        nprogress.done();

    },
    methods: {

        async getHistory ( page: number, type?: string ): Promise<void> {

            try {

                let paymentList = this.paymentList.slice();
                if ( page === 1 ) {

                    paymentList = [];

                }
                let data, items;
                if ( paymentList.length === 0 ) {

                    ({ items } = await getPaymentHistory( this.year, 1, type ));

                } else {

                    ({ items } = await getPaymentHistory( this.year, page, type ));

                }
                for ( let item of items ) {

                    for ( const orderItem of item.items ) {

                        if ( orderItem.productType !== 'cloud_data_add_on_plan' ) {

                            try {

                                orderItem.plan = await productsManager.getPlanById( item.items[0].productId );

                            } catch ( e ) {

                                console.error( e );

                            }

                        }

                    }

                }
                data = items;
                this.hasMore = data.length === this.per;
                paymentList.push( ...data );

                for ( let payment of paymentList ) {

                    let totalTax = 0;
                    for ( let tax of payment.taxData.details ) {

                        totalTax += parseFloat( tax.tax );

                    }
                    payment.totalTax = totalTax;

                }
                console.log( paymentList );
                this.paymentList = paymentList;

            } catch ( err ) {

                console.error( err );

            }

        },
        timeResolve ( date: number ): ITimeObject {

            return timeResolve( date );

        },
        date ( date: number ): string {

            let dateObj = timeResolve( date );
            return `${dateObj.month}/${dateObj.dateOfMonth}/${dateObj.year}`;

        },
        async infiniteHandler ( $state ): Promise<void> {

            await this.getHistory( ++this.page );
            $state.loaded();

        },
        showless () {

            this.paymentList.splice( this.per );
            this.page = 1;
            $( document ).scrollTop( 0 );

        },
        async goPay ( subId ): Promise<void> {

            try {

                let orderObj = await getOrderDetailById( subId );
                await router.push({

                    path: '/checkout/pay/',
                    query: {
                        o_id: orderObj.id,
                        mode: orderObj.items[0].context.action as string,
                        platform: config.platform
                    }

                });

            } catch ( err ) {

                const symbol = ( err as AxiosError ).response?.data.error.symbol;
                if ( symbol === 'order_not_acceptable' ) {

                    window.location.reload();

                } else if ( symbol === 'order_expired' ) {

                    unfoldError( 'order_complete.fail_reason2' );

                }

            }

        },
        handleYearChange ( year: string ): void  {

            if ( !this.initialized ) {

                return;

            }
            this.defaultYearSelected = year;
            if ( year === 'total' ) {

                this.year = 'all';

            } else {

                this.year = year;

            }

        },
        async handleOptionChange ( type: string ): Promise<void>  {

            if ( !this.initialized ) {

                return;

            }
            this.paymentList = [];
            this.type = type;
            this.page = 1;
            this.defaultSelected = type;
            if ( type !== 'total' ) {

                await this.getHistory( 1, type );

            } else {

                await this.getHistory( 1 );

            }

        },
        dialogMounted ( ref: any ): void {

            if ( this.dialogStack.length === 0 ) {

                $( $( 'html' )[0] ).toggleClass( 'dialogActivated' );

            }
            this.dialogStack.push( ref );

        },
        dialogDestroyed (): void {

            this.dialogStack.pop();
            if ( this.dialogStack.length === 0 ) {

                $( $( 'html' )[0] ).toggleClass( 'dialogActivated' );

            }

        },
        serviceSelectorKey(): string {

            let yearString = typeof this.year === 'number' ? String( this.year ) : this.year; // 显式将 year 转换为字符串
            let mobileString = String( this.isMobile );

            return yearString + mobileString;

        },
        getSimRelateItems( payment: IOrder ) {

            return payment.items.filter( item => item.context.associateSimCards && item.context.associateSimCards.length > 0 && item.context.associateDevices?.length === 0 );

        },
        showDetail( index: number ) {

            this.detailDialog.paymentIndex = index;
            this.detailDialog.show = true;

        }

    },
    watch: {

        async year ( ): Promise<void> {

            if ( this.type !== 'total' ) {

                await this.getHistory( 1, this.type );

            } else {

                await this.getHistory( 1 );

            }

        }

    },
    computed: {
        selectorStyle (): ISelectorStyle {

            return !this.isMobile ? {
                widthOut: 3,
                heightOut: 0.48,
                widthIn: 3,
                heightIn: 0.48,
                selectMarginLeft: 0.16,
                triangleRight: 0.16,
                maxHeight: 3.08,
                fontSizeIn: 0.14,
                fontSizeOut: 0.16
            } : {
                widthOut: -1,
                heightOut: 0.34,
                widthIn: -1,
                heightIn: 0.34,
                selectMarginLeft: 0.1,
                triangleRight: 0.1,
                maxHeight: 4.4,
                fontSizeIn: 0.14,
                fontSizeOut: 0.14
            };

        },
        isMobile(): boolean {

            return this.$store.getters.isMobile;

        },
        client (): string {

            return config.oem;

        },
        hasData(): boolean {

            return this.paymentList.length > 0;

        }
    }

});
</script>

<style scoped lang="less">
.payment-history{
    max-width: 1200px;
    box-sizing: border-box;
    margin: 60px auto;
    padding: 78px 100px;
    display: flex;
    flex-direction: column;
    gap: 30px;
    @media @mobile{
        padding: 0 20px;
        margin: 30px 0;
    }
    .sub-note{
        color: #777;
    }
    h1{
        font-family: @font_01;
        font-size: 36px;
        font-weight: normal;
        text-align: center;
        @media @mobile{
            font-size:  40px;
        }
    }
    .year-filter{
        font-size: 18px;
        position: relative;
        margin-bottom: -30px;
        border-bottom: 1px solid @line;
        @media @mobile{
            padding: 0 15px;
            font-size: 0.28rem;
        }
        li{
            font-weight: 600;
            float: left;
            position: relative;
            cursor: pointer;
            padding: 10px 20px;
            &.active{
                color: @brand_lightest;
                &:after{
                    content: '';
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    display: block;
                    width: 100%;
                    height: 2px;
                    background-color: @brand_lightest;
                }
            }
        }
    }
    .type-filter{

        span{
            font-size: .18rem;
            margin-right: .2rem;

            @media @mobile {
                font-size: 14px;
                font-weight: 500;
                display: block;
                margin-bottom: 10px;
            }
        }
    }

    .reo-table{
        margin-top: 27px;
        table-layout: fixed;
        border-collapse: collapse;
        width: 100%;
        @media @mobile{
            display: none;
        }
        thead{
            background-color: @bg_02;
            th{
                padding: 28px 5px;
                width: calc( 100% / 7);
                border: 1px solid @fill_primary;
                box-sizing: border-box;
            }
        }
        tbody{
            background-color: @bg_01;
            td{
                line-height: normal;
                box-sizing: border-box;
                margin: 0;
                font-size: 14px;
                font-weight: 500;
                color: @font_secondary;
                border: 1px solid @fill_primary;
                padding: 16px;
                &:last-of-type{
                    text-align: center;
                }
                .wrapper{
                    max-height: 100px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                .action{
                    color: @theme;
                    cursor: pointer;
                }
            }
        }
        .thead{
            display: flex;
            background-color: @bg_02;
            li{
                font-size: 16px;
                font-weight: normal;
                color: @font_primary;
            }
        }
        .tbody{
            ul{
                display: flex;
            }
        }
    }
    .no-data{
        display: flex;
        flex-direction: column;
        gap: 8px;
        font-weight: 500;
        align-items: center;
        justify-content: center;
        margin-top: 154px;
        margin-bottom: 147px;
    }
    .refunding-amount{
        font-size: 0.14rem;
    }
    .more-payments{
        font-weight: 500;
        font-size: 0.16rem;
        @media @mobile{
            margin-left: 15px;
            display: none;
        }
        i{
            vertical-align: middle;
            margin-left: 0.1rem;
            font-size: 0.12rem;
        }
    }
    .less-payments{
        font-size: 0.26rem;
        font-weight: 500;
        color: @theme;
        margin-left: 15px;
        i{
            font-size: 0.16rem;
            vertical-align: middle;
            margin-left: 0.1rem;
        }
        @media @pc{
            display: none;
        }
    }
    .reo-table-mobile{
        @media @pc{
            display: none;
        }
        @media @mobile{
            display: block;
            .cards{
                flex-direction: column;
                gap: 30px;
                display:flex;
            }
            ul{
                font-size: 0;
                display: flex;
                gap: 10px;
                flex-direction: column;
            }
            li{
                display: flex;
                justify-content: space-between;
            }
            li label{
                font-size: 14px;
                font-weight: normal;
                width: 140px;
                display: inline-block;
                vertical-align: top;
            }
            li>span{
                font-size: 12px;
                color: @font_secondary;
                display: inline-block;
                width: 175px;
            }
            .invoice-li{
                justify-content: center;
                padding: 10px 0;
            }
        }

    }
    @media @pc{
        .loading{
            display: none;
        }
    }
    .payment-product{
        display: block;
    }

    .text-link.invoice{
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        color: @b_6;
        &:hover{
            text-decoration: underline;
        }
        @media @mobile{
            font-size: 14px;
        }
    }
}
</style>
